import React, {useState, useEffect} from 'react'
import LearnMoreBox from "../sections/learnMoreBox"; 
import contentFilterStyles from "../components/css/contentFilterStyles.module.scss"

export default function({data, title}){
    const [filter, setFilter] = useState("local")
    const [subselected, setSubselected] = useState(0)

    let active="";
    let subActive = "";

    useEffect(function(){
        setSubselected(0);
    }, [filter])

    return (
        <article className={"filterbox " + contentFilterStyles.content}>
            <header>
                <h2>{title}</h2>
                <div className={"filterOption " + contentFilterStyles.filters}>
                    {
                        
                        Object.keys(data).map((group,schools)=>{
                            active = (filter==group) ? contentFilterStyles.active : "";
                            // and select the first school
                            if(active){
                                //setSubselected(0);
                            }

                            return(
                            <div className={"text " + contentFilterStyles.option + " "+ active}>
                                <span onClick={e=>{setFilter(group)}}>{group}</span>
                            </div>
                            )
                        })
                        
                    }
                </div>
            </header>

            <div className={contentFilterStyles.list}>
                {
                    
                    data[filter].map((school, i) =>{
                        subActive = (i==subselected) ? contentFilterStyles.active : "";
                            
                        return(
                        <p className={subActive} onClick={e=>setSubselected(i)}>{school.name}</p>
                        )
                    })
                    
                }
            </div>

            <div className={contentFilterStyles.detail}>
                <LearnMoreBox cta="Contact Us Today!" ctaIntro="Questions about degree pathway options through VanArts?" coverImage={data[filter][subselected].cover}>
                    <div dangerouslySetInnerHTML={{__html: data[filter][subselected].description}}></div>
                </LearnMoreBox>
            </div>
            
        </article>
    )
}